/* DARK MODA */
var $dark = $(".header-wrapper");

if (localStorage.getItem("darkmode") === "true") {
  $dark.addClass("dark-header");
  $(
    ".price-item--regular,p,h1,h2,h3,h4,h5,h6,ul,li,a,span,.footer__copyright.copyright__content a:hover,.footer__copyright,.header__icons.header__icon svg,.header__inline-menu.list-menu--inlineli.header__menu-item.header__active-menu-item, .header__inline-menu.list-menu--inlineli.header__menu-item,.header-wrapper.header.header__heading span,.card-wrapper.card__content.card-information.price, .card-wrapper.card__content.card__heading,.announcement-bar .announcement-bar__message, .icon-caret, .form__label, .product-form__input, .accordion .icon-accordion, .cart-notification-product__name, .cart-items"
  ).addClass("light-text");
  $(
    ".color-background-2, .video-section__media, .gradient, .product-form__submit, #cart-notification-button"
  ).addClass("dark-background");
  $(".darkmode-button").addClass("darkmode-button-light");
  $(".light-logo").addClass("logo-hide");
  $(".dark-logo").addClass("logo-display");
}

$(".darkmode-button").click(function () {
  $dark.toggleClass("dark-header");
  $(
    ".price-item--regular,p,h1,h2,h3,h4,h5,h6,ul,li,a,span,.footer__copyright.copyright__content a:hover,.footer__copyright,.header__icons.header__icon svg,.header__inline-menu.list-menu--inlineli.header__menu-item.header__active-menu-item, .header__inline-menu.list-menu--inlineli.header__menu-item,.header-wrapper.header.header__heading span,.card-wrapper.card__content.card-information.price, .card-wrapper.card__content.card__heading,.announcement-bar .announcement-bar__message, .icon-caret, .form__label, .product-form__input, .accordion .icon-accordion, .cart-notification-product__name, .cart-items"
  ).toggleClass("light-text");
  $(
    ".color-background-2, .video-section__media, .gradient, .product-form__submit, #cart-notification-button"
  ).toggleClass("dark-background");
  $(".darkmode-button").toggleClass("darkmode-button-light");
  $(".light-logo").toggleClass("logo-hide");
  $(".dark-logo").toggleClass("logo-display");

  localStorage.setItem("darkmode", $dark.hasClass("dark-header"));
});

$("#mode-switch").click(function () {
  if (localStorage.getItem("darkmode") === "true") {
    $("#mode-switch").text("Light Mode");
  } else {
    $("#mode-switch").text("Dark Mode");
  }
});

$(document).ready(function () {
  if (localStorage.getItem("darkmode") === "true") {
    $("#mode-switch").text("Light Mode");
  } else {
    $("#mode-switch").text("Dark Mode");
  }
});
